var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CornerLeftUpIcon, Trans, Typography } from '@lucidlink/uicore';
export const ParentDirCell = () => (_jsxs(Box, { align: "center", gap: "l", children: [_jsx(CornerLeftUpIcon, { color: "accent" }), _jsx(Typography, { kind: "generic-small", children: _jsx(Trans, { children: "Parent folder" }) })] }));
_react_refresh_temp_1 = ParentDirCell;
$RefreshReg$(_react_refresh_temp_1, "ParentDirCell");
